// extracted by mini-css-extract-plugin
module.exports = {"paymentBox":"CheckOut_paymentBox__3K57p"};